import axios from "axios"
import {setSecretKey} from "../utils/AES256";
import { getApiHost } from "../config/routes.config";

const initializeApp = () => {

    // Setting base URL for all API request via axios
    axios.interceptors.request.use((config) => {
        const currentPath = window.location.pathname;
        const apiHost = getApiHost(currentPath);
        config.baseURL = apiHost || process.env.REACT_APP_BASE_URL;
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    // Set secret key for AES encryption/decryption
    const secretKey = process.env.REACT_APP_SECRET_KEY
    setSecretKey(secretKey);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        // dev code
    } else {
        // production code
    }

}

export default initializeApp
